import { render } from "./skeltonNatinalityPrice.vue?vue&type=template&id=7ef2da4c"
import script from "./skeltonNatinalityPrice.vue?vue&type=script&lang=js"
export * from "./skeltonNatinalityPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__